<template>
  <footer class="footer">
    <div class="container main">
      <div class="row">
        <div class="col-md-6">
          <a :href="route('index')">
            <img src="images/logo/logo-full-white.svg" class="logo" alt="Veximus Technologies" />
          </a>
          <p>{{ t('Malaysia #1 software startup based in Petaling Jaya that specialised in developing premium websites, mobile applications and other software with the lowest price guaranteed.') }}</p>
        </div>
      </div>
      <div class="row contact">
        <div class="col-12 col-md-4 col-lg-4">
          <div>{{ t('Client Hotline') }}</div>
          <a href="tel:+60192918967" rel="noopener">+603 7624 8096</a>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div>{{ t('Support Email') }}</div>
          <a href="mailto:support@veximus.com.my" rel="noopener">support@veximus.com.my</a>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <div class="icons">
            <a href="https://www.facebook.com/veximus" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'facebook-f']" />
            </a>
            <a href="https://www.instagram.com/vxms_official" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a href="https://wa.me/+60376248096" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'whatsapp']" />
            </a>
            <a href="https://twitter.com/vxms_official" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </a>
            <a href="https://www.youtube.com/channel/UChdhOtxF7ITkm3WIcI6BsvQ" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'youtube']" />
            </a>
            <a href="https://my.linkedin.com/company/veximus" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'linkedin-in']" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid secondary">
      <div class="container p-0">
        <div class="row">
          <div class="col-12 col-xl-8">
            <div>
              <a :href="route('index')">{{ business.name }}}. ({{ business.registration }}})</a>
              &copy; {{ new Date().getFullYear() }} {{ t('All rights reserved.') }}
            </div>
            {{ t('The information posted on this site is covered by the Intellectual Property Protection of Malaysia. Use of materials is only allowed with the written permission of the owners, the reference to the source is obligated. All trademarks displayed on this site are the property of their respective owners.') }}
          </div>
          <div class="col-12 col-xl-4 d-none d-xl-block">
            <div class="partners">
              <img src="images/ui/footer-eghl.svg" class="partner" alt="eGHL" />
              <img src="images/ui/footer-stripe.svg" class="partner" alt="Stripe" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.footer {
  background: #222;
  color: rgb(255 255 255 / 75%);
  font-size: 0.9rem;
  position: relative;

  .main {
    padding-top: 3rem;
    padding-bottom: 3rem;

    .logo {
      height: 30px;
      margin: 0.5rem 0 1.5rem;
      opacity: 0.75;
    }

    .contact {
      border-top: solid 1px rgb(255 255 255 / 25%);
      margin-top: 2rem;
      padding-top: 2rem;

      a {
        color: $primary;
        font-family: 'Rubik', sans-serif;
        font-size: 1.25rem;
        letter-spacing: -0.03rem;
      }
    }

    .icons {
      display: flex;
      justify-content: flex-end;

      a {
        align-items: center;
        background: $primary;
        border-radius: 1.35rem;
        color: #fff;
        display: flex;
        height: 50px;
        justify-content: center;
        margin: 0 0.15rem;
        width: 50px;

        @media (max-width: 575.98px) {
          border-radius: 1rem;
          height: 40px;
          width: 40px;
        }
      }

      @media (max-width: 991.98px) {
        justify-content: left;
        margin-top: 2rem;
      }
    }
  }

  .secondary {
    background: rgb(255 255 255 / 2.5%);
    color: rgb(255 255 255 / 50%);
    font-size: 0.65rem;
    font-weight: 300;
    padding-top: 1.5rem;
    padding-bottom: 2rem;

    .partners {
      display: flex;
      justify-content: flex-end;

      .partner {
        margin: 0 0.5rem;
        object-fit: contain;
        opacity: 0.25;
        width: 80px;

        &:nth-child(2) {
          padding-top: 0.25rem;
        }
      }
    }
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';

export default {
  computed: {
    business() {
      return this.$page.props.business;
    }
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'All rights reserved.': 'All rights reserved.',
          'Client Hotline': 'Client Hotline',
          'Malaysia #1 software startup based in Petaling Jaya that specialised in developing premium websites, mobile applications and other software with the lowest price guaranteed.': 'Malaysia #1 software startup based in Petaling Jaya that specialised in developing premium websites, mobile applications and other software with the lowest price guaranteed.',
          'Support Email': 'Support Email',
          'The information posted on this site is covered by the Intellectual Property Protection of Malaysia. Use of materials is only allowed with the written permission of the owners, the reference to the source is obligated. All trademarks displayed on this site are the property of their respective owners.': 'The information posted on this site is covered by the Intellectual Property Protection of Malaysia. Use of materials is only allowed with the written permission of the owners, the reference to the source is obligated. All trademarks displayed on this site are the property of their respective owners.'
        },
        'zh-MY': {
          'All rights reserved.': '版权所有。',
          'Client Hotline': '客户热线',
          'Malaysia #1 software startup based in Petaling Jaya that specialised in developing premium websites, mobile applications and other software with the lowest price guaranteed.': '微星科技是马来西亚排名第一的软件初创公司，成立于雪兰莪州的八打灵再也。我们自从成立以来便致力于以最低的价格为我们的客户开发最优质的网站，移动应用程序以及其他软件。',
          'Support Email': '电邮地址',
          'The information posted on this site is covered by the Intellectual Property Protection of Malaysia. Use of materials is only allowed with the written permission of the owners, the reference to the source is obligated. All trademarks displayed on this site are the property of their respective owners.': '本站上发布的所有信息皆受马来西亚知识产权保护局所保护。你仅能够在所有者的书面许可下，方可使用本站材料与素材，所有材料与素材的使用必须注明出处。本站上显示的所有商标均为其各自所有者的财产。'
        },
        'ms-MY': {
          'All rights reserved.': 'Hak Cipta Terpelihara.',
          'Client Hotline': 'Talian Pelanggan',
          'Malaysia #1 software startup based in Petaling Jaya that specialised in developing premium websites, mobile applications and other software with the lowest price guaranteed.': 'Syarikat teknologi permulaan #1 di Malaysia yang berpusat di Petaling Jaya, Selangor. Kami pakar dalam bidang teknologi, khususnya membekalkan laman web premium, aplikasi mudah alih dengan jaminan harga yang paling rendah.',
          'Support Email': 'Alamat Emel',
          'The information posted on this site is covered by the Intellectual Property Protection of Malaysia. Use of materials is only allowed with the written permission of the owners, the reference to the source is obligated. All trademarks displayed on this site are the property of their respective owners.': 'Semua maklumat yang diterbitkan di laman web ini dilindungi oleh Agensi Perlindungan Harta Intelek Malaysia. Penggunaan bahan hanya dibenarkan dengan izin bertulis dari pemilik, rujukan ke sumber wajib dilakukan. Semua logo yang dipaparkan di laman web ini adalah hak milik pemiliknya masing-masing.'
        }
      }
    });

    return { t };
  }
};
</script>
